import { useEffect, useState } from "react";

import { useAuthStore, useBusinessUnitStore } from "@type/store";
import { checkHasAccess } from "helpers/checkHasAccess";

type UseGetAccessProps = {
  requiredAccessRights?: number[];
  superAdminOnly?: boolean;
};

export const useGetAccess = ({
  requiredAccessRights,
  superAdminOnly,
}: UseGetAccessProps) => {
  const buAccessRight = useBusinessUnitStore((state) => state.buAccessRight);
  const appAccessRight = useBusinessUnitStore((state) => state.appAccessRight);

  const loadingBU = useBusinessUnitStore((state) => state.isLoading);
  const user = useAuthStore((state) => state.user);

  const [givenAccess, setGivenAccess] = useState<boolean>();

  useEffect(() => {
    if (superAdminOnly && !user.isSuperAdmin) {
      setGivenAccess(false);
    } else if (requiredAccessRights?.length) {
      setGivenAccess(
        checkHasAccess(requiredAccessRights, {
          ...appAccessRight,
          ...buAccessRight,
        })
      );
    } else {
      setGivenAccess(true);
    }
  }, [
    requiredAccessRights,
    superAdminOnly,
    loadingBU,
    user.isSuperAdmin,
    appAccessRight,
    buAccessRight,
  ]);

  return {
    loading: givenAccess === undefined,
    givenAccess,
  };
};
